import React from "react";
import { Grid, TextField, Typography } from "@material-ui/core";
import { useSelector } from "react-redux";

export const UnitForm = ({ navigate }) => {
  const { settlement } = useSelector((state) => state.routesStatus);
  const { unit, driver, helper, secondHelper, routes } = settlement;

  return (
    <>
      <Grid item xs={12}>
        <Typography
          variant="body1"
          color="primary"
          component="h3"
          style={{ marginBottom: 15 }}
        >
          Unidad
        </Typography>
      </Grid>
      <Grid item xs={12} md={2}>
        <TextField
          label="Fecha"
          variant="outlined"
          fullWidth
          margin="dense"
          name="date"
          value={settlement?.routes?.end?.time}
          disabled
        />
      </Grid>
      <Grid item xs={12} md={2}>
        <TextField
          label={
            unit.unitCapacity > 0
              ? "No. de Unidad / Capacidad"
              : "No. de Unidad"
          }
          variant="outlined"
          fullWidth
          margin="dense"
          value={
            unit.unitCapacity > 0
              ? `${unit.number} / ${unit.unitCapacity} lts`
              : unit.number
          }
          disabled
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <TextField
          label="Chofer"
          variant="outlined"
          fullWidth
          margin="dense"
          value={driver?.name}
          disabled
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <TextField
          label="Ayudante No-1"
          margin="dense"
          variant="outlined"
          fullWidth
          value={helper?.name}
          disabled
          // disabled={helper?.name ? true : false}
        />
      </Grid>
      { secondHelper && secondHelper !== null && (
        <Grid item xs={12} md={1}>
          <TextField
            label="Ayudante No-2"
            margin="dense"
            variant="outlined"
            fullWidth
            value={secondHelper?.name}
            disabled
            // disabled={helper?.name ? true : false}
          />
        </Grid>
      )}
    </>
  );
};
